import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { resetFirstLastMargins } from '@/css/resources/placeholders.css';
import { fontStyle, fluidValues } from '@/css/resources/mixins.css';

const getDynamicStyles = (styles) =>
	cssObj(
		fluidValues(
			'marginTop',
			styles?.margin?.top?.[0],
			styles?.margin?.top?.[1]
		),
		{
			'.supt-figure__figcaption': fontStyle({
				...styles?.figcaption?.typography,
				textAlign: styles?.figcaption?.textAlignment,
				color: styles?.figcaption?.color,
			}),
		}
	);

const getStyles = (styles) =>
	css(getDynamicStyles(styles), {
		'.supt-figure__image': {
			maxWidth: '100%',
		},

		'.supt-figure__figcaption': resetFirstLastMargins,

		/* with link */
		'&.supt-isSticky': {
			position: 'sticky',
			top: '80px',
		},
	});

// edit

const getEditStyles = (ratioWidth, ratioHeight) =>
	css({
		display: 'block',
		position: 'relative',
		paddingTop:
			ratioWidth !== 0
				? `calc(100% * (${ratioHeight} / ${ratioWidth}))`
				: 0,
		margin: 0,
		height: ratioWidth !== 0 ? '0' : undefined,

		'.supt-figure__image': {
			padding: '0 !important',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
		},

		'.supt-figure__imagePreview': {
			display: 'block',
			maxWidth: '100%',
			maxHeight: '100%',
		},

		'.editor-post-featured-image__toggle': {
			backgroundColor: '#ced1d9',
			minHeight: '0px',
		},

		'.supt-figure__isCover': {
			width: '100%',
			height: '100%',
			objectFit: 'cover',
		},

		'.supt-figure__deleteButton': {
			position: 'absolute',
			top: 0,
			left: 0,
			backgroundColor: 'white',
			border: '1px solid black',

			'.dashicon': {
				margin: 0,
			},
		},
	});

export { getStyles, getEditStyles };
